import React, { useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import { Form } from '@unform/web';
import { updateUserRequest } from '~/store/modules/user/actions';
import api from '~/services/api';
// Importando componentes
import Input from '~/components/Form/Input';
import Button from '~/components/Form/Button';
import Card from '~/components/Card';
import Select from '~/components/Form/Select';
import Load from '~/components/Load';

import { Container } from './styles';

export default function Perfil() {
  const inputRef = useRef(null);
  const [carregar, setCarregar] = useState(false);
  const [loading, setLoading] = useState(false);
  const [times, setTimes] = useState([]);
  const [timeSelect, setTimeSelect] = useState([]);

  const dispatch = useDispatch();
  const user = useSelector(state => state.user.profile);

  useEffect(() => {
    async function getTimes() {
      setLoading(true);
      const response = await api.get('/times-select');

      const dataTime = response.data.map(time => ({
        value: time.id,
        label: time.name,
      }));

      const dataSelectTime = dataTime.filter(time => {
        return time.value === Number(user.time_id);
      });

      setTimes(dataTime);
      setTimeSelect(dataSelectTime[0]);
      setLoading(false);
    }

    getTimes();
  }, [user.time_id]);

  /**
   * Funcoes
   */

  async function handlerSubmit(data) {
    try {
      setCarregar(true);
      inputRef.current.setErrors({});
      let schema;

      if (user.provider === '4') {
        schema = Yup.object().shape({
          name: Yup.string().required('Preencha o campo nome'),
          time_id:
            data.time_id === undefined
              ? null
              : Yup.string('Selecione um time').required('Selecione um time'),
          email: Yup.string()
            .email('Preencha com um e-mail valido')
            .required('Preencha o campo de e-mail'),
          oldPassword: Yup.string(),
          passwordNew: Yup.string().when('oldPassword', (oldPassword, field) =>
            oldPassword
              ? field.required('Preencha o campo de nova senha')
              : field
          ),
          confirmPassword: Yup.string()
            .oneOf(
              [Yup.ref('passwordNew')],
              'Confirmação de senha precisa ser igual a nova senha'
            )
            .when('password', (password, field) =>
              password
                ? field.required('Preencha o campo de nova senha')
                : field
            ),
        });
      } else {
        schema = Yup.object().shape({
          name: Yup.string().required('Preencha o campo nome'),
          email: Yup.string()
            .email('Preencha com um e-mail valido')
            .required('Preencha o campo de e-mail'),
          oldPassword: Yup.string(),
          passwordNew: Yup.string().when('oldPassword', (oldPassword, field) =>
            oldPassword
              ? field.required('Preencha o campo de nova senha')
              : field
          ),
          confirmPassword: Yup.string()
            .oneOf(
              [Yup.ref('passwordNew')],
              'Confirmação de senha precisa ser igual a nova senha'
            )
            .when('password', (password, field) =>
              password
                ? field.required('Preencha o campo de nova senha')
                : field
            ),
        });
      }

      await schema.validate(data, {
        abortEarly: false,
      });

      data.time_id =
        data.time_id === undefined ? timeSelect.value : data.time_id;

      data.password = data.passwordNew;

      dispatch(updateUserRequest(data));
    } catch (err) {
      setCarregar(true);
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message;
        });
        inputRef.current.setErrors(validationErrors);
      } else {
        toast.error('Error ao cadastrar o usuario, verifique os dados');
      }
    } finally {
      setCarregar(false);
    }
  }

  if (loading) {
    return <Load />;
  }

  return (
    <Container>
      <h4>Editar Perfil</h4>
      <Card>
        <Form
          ref={inputRef}
          onSubmit={handlerSubmit}
          autoComplete="off"
          initialData={user}
        >
          <Input icon="MdPerson" label="Nome" name="name" type="text" />
          <Input icon="MdEmail" label="E-mail" name="email" type="email" />
          {user.provider !== '1' && user.provider !== '3' && (
            <Select
              name="time_id"
              labelSelect="Times"
              options={times}
              onChange={e => setTimeSelect(e)}
              defaultValue={timeSelect}
            />
          )}
          <hr />
          <Input
            icon="MdLock"
            label="Senha antiga"
            name="oldPassword"
            type="password"
          />
          <Input
            icon="MdLock"
            label="Senha nova"
            name="passwordNew"
            type="password"
          />
          <Input
            icon="MdLock"
            label="Confirmação de senha"
            name="confirmPassword"
            type="password"
          />
          <Button tamanho="40px" load={carregar}>
            Editar
          </Button>
        </Form>
      </Card>
    </Container>
  );
}
